import request from '../common/request.js';


//新增应用类型
export function AddApp(payload) {
    return request.post('/app/AddApp', payload);
}

//获取应用列表
export function GetAppsList(payload) {
    return request.post('/app/GetAppsList', payload);
}


//更新应用类型
export function UpdateApp(payload) {
    return request.post('/app/UpdateApp', payload);
}

//删除应用类型
export function DeleteApp(payload) {
    return request.get('/app/DeleteApp', payload);
}


//新增应用版本
export function AddAppLog(payload) {
    return request.post('/app/AddAppLog', payload);
}

//获取应用版本列表
export function GetAppLogList(payload) {
    return request.post('/app/GetAppLogList', payload);
}


//更新应用版本
export function UpdateAppLog(payload) {
    return request.post('/app/UpdateAppLog', payload);
}

//删除应用版本
export function DeleteAppLog(payload) {
    return request.get('/app/DeleteAppLog', payload);
}
export function GetAppVersionInfo(payload) {
    return request.get('/app/GetAppVersionInfo', payload);
}